import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62b6968a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=62b6968a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6968a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageContentSections: require('/codebuild/output/src3208117147/src/studio-frank/components/PageContentSections.vue').default,Footer: require('/codebuild/output/src3208117147/src/studio-frank/components/global/Footer.vue').default,SEO: require('/codebuild/output/src3208117147/src/studio-frank/components/global/SEO.vue').default,PreviewModeWrapper: require('/codebuild/output/src3208117147/src/studio-frank/components/global/PreviewModeWrapper.vue').default})
